import { render, staticRenderFns } from "./InvoiceOwnerUpdatedToaster.vue?vue&type=template&id=4491f12d&scoped=true"
import script from "./InvoiceOwnerUpdatedToaster.vue?vue&type=script&lang=js"
export * from "./InvoiceOwnerUpdatedToaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4491f12d",
  null
  
)

export default component.exports